import React from 'react';
import { FUEL_TYPES, FUEL_META } from './constants';  // Changé
import { Modal, Field, ModalFooter } from './modalComponents';  // Changé

const TankModal = ({ isOpen, onClose, editingTank, tankForm, setTankForm, onSave, saving }) => {
  if (!isOpen) return null;

  const setForm = (key, val) => setTankForm(prev => ({ ...prev, [key]: val }));

  return (
    <Modal
      title={editingTank
        ? `Edit Tank · ${editingTank.tank_name || FUEL_META[editingTank.fuel_type]?.label}`
        : 'Add Fuel Tank'}
      onClose={onClose}
    >
      <div className="space-y-3">
        <Field label="Fuel type *">
          <select 
            value={tankForm.fuel_type} 
            onChange={e => setForm('fuel_type', e.target.value)}
            disabled={!!editingTank}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm disabled:opacity-50"
          >
            {FUEL_TYPES.map(t => <option key={t} value={t}>{FUEL_META[t]?.label || t}</option>)}
          </select>
        </Field>
        
        <Field label="Tank name">
          <input 
            type="text" 
            placeholder="e.g. Main Jet-A Tank"
            value={tankForm.tank_name} 
            onChange={e => setForm('tank_name', e.target.value)}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
          />
        </Field>
        
        <div className="grid grid-cols-2 gap-3">
          <Field label="Capacity (gallons)">
            <input 
              type="number" 
              min="0" 
              placeholder="e.g. 12000"
              value={tankForm.capacity_gallons} 
              onChange={e => setForm('capacity_gallons', e.target.value)}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
            />
          </Field>
          <Field label="Current volume (gal) *">
            <input 
              type="number" 
              min="0" 
              placeholder="e.g. 8000"
              value={tankForm.current_volume_gallons} 
              onChange={e => setForm('current_volume_gallons', e.target.value)}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
            />
          </Field>
          <Field label="Reorder level (gal)">
            <input 
              type="number" 
              min="0" 
              placeholder="e.g. 2000"
              value={tankForm.reorder_level_gallons} 
              onChange={e => setForm('reorder_level_gallons', e.target.value)}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
            />
          </Field>
          <Field label="Retail price ($/gal) *">
            <input 
              type="number" 
              min="0" 
              step="0.001" 
              placeholder="e.g. 5.85"
              value={tankForm.price_per_gallon} 
              onChange={e => setForm('price_per_gallon', e.target.value)}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
            />
          </Field>
        </div>
      </div>
      <ModalFooter 
        onCancel={onClose} 
        onSave={onSave}
        saving={saving} 
        disabled={!tankForm.current_volume_gallons || !tankForm.price_per_gallon}
        label={editingTank ? 'Save Changes' : 'Create Tank'} 
      />
    </Modal>
  );
};

export default TankModal;